class NavMobile extends HTMLElement {
    constructor() {
        super();
        this.parentElements = this.querySelectorAll('.main-menu-drawer-parent__item');
        this.initGrandChildSwiper();
        this.resizeFlag = false;
    }

    initGrandChildSwiper() {
        this.parentElements.forEach(parentElement => {
            const swiperContainerParent = parentElement.querySelector('.menu-drawer__menu-child-menu');

            // 检查swiperContainerParent是否存在
            if (!swiperContainerParent) {
                // console.warn('未找到 menu-drawer__menu-child-menu 元素', parentElement);
                return;
            }

            const swiperContainer = swiperContainerParent.querySelector('.menu-drawer__menu-grandchild-list');
            // const mbnavtitle = parentElement.querySelector('.main-menu-drawer-summary.menu-drawer__menu-item');
            if (!swiperContainer) {
                // console.warn('未找到 menu-drawer__menu-grandchild-list 元素', swiperContainerParent);
                return;
            }

            const switchList = swiperContainerParent.querySelector('.menu-drawer__menu-childlink-list');

            const swiperInstance = new Swiper(swiperContainer, {
                slidesPerView: 1,
                allowTouchMove: false,
                autoHeight: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                }
            });

            parentElement.swiperInstance = swiperInstance;
            // this.togglecontent(mbnavtitle);
            this.setupSwitchLinks(switchList, parentElement.swiperInstance);
        });
    }

    setupSwitchLinks(switchList, swiperInstance) {
        const switchLinks = switchList.querySelectorAll('.switch-menu-summary');
        switchLinks.forEach((link, index) => {
            link.addEventListener('click', () => {
                // console.log("click");
                if (!this.resizeFlag) {
                    window.dispatchEvent(new Event('resize'));
                    this.resizeFlag = true;
                }
                let nowcgbox = swiperInstance.slides[index];
                // console.log($(nowcgbox).find(".swiper-wrapper").children().length);
                if ($(nowcgbox).find(".swiper-wrapper").children().length > 0) {
                    $(link).addClass("active").siblings().removeClass("active");
                    swiperInstance.slideTo(index);
                }

            });
        });
    }


}

customElements.define('nav-mobile', NavMobile);
